import { Component, OnInit, Input, EventEmitter } from "@angular/core";
import {  AuxJasper,  ParametroJasper, Privilegios} from "../../entidades/entidades";
import { ObtenerUsuarioPorCargoService } from "../../servicios/obtener-usuario-por-cargo.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { CatUsuariosService } from "../../servicios/cat-usuarios.service";
import { ActivatedRoute, Router} from "@angular/router";
import { PrivilegiosService } from 'app/servicios/privilegios.service';


declare var $: any;


@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.css']
})
export class ReportesComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  auxJasper: AuxJasper;

  public auxJasperCancelado$ = new EventEmitter<AuxJasper>();
  public auxJasperReporte$ = new EventEmitter<AuxJasper>();
  public auxJasperFechas$ = new EventEmitter<AuxJasper>();
  public auxJasperMes$ = new EventEmitter<AuxJasper>();
  public auxJasperIngresos$ = new EventEmitter<AuxJasper>();
  public jasperInputExporta$ = new EventEmitter<AuxJasper>();
  public auxJasperIngresosFacturados$ = new EventEmitter<AuxJasper>();
  public auxJasperRutasProcesadas$  = new EventEmitter<AuxJasper>();
  public auxJasperReporte1$ = new EventEmitter<AuxJasper>();
  public auxJasperReporte2$ = new EventEmitter<AuxJasper>();

  operaciones_mes: boolean = false;
  operaciones_anteriores: boolean = false;
  operaciones_canceladas: boolean = false;
  operaciones_padron: boolean = false;
  operaciones_ingresos: boolean = false;
  operaciones_facturados: boolean = false;
  conPrivilegio: boolean = false;

  boton_mes: boolean = false;
  boton_anteriores: boolean = false;
  boton_canceladas: boolean = false;
  boton_padron: boolean = false;
  boton_ingresos: boolean = false;
  boton_facturados: boolean = false;

  boton_seleccionado = 0;

  buscando: boolean = false;

  public cierre_fecha: any;
  public apertura_fecha: any;

  public progressBar = false;
  public progressButton = false;

  display: boolean = false;
  auxJasperRutasProcesadas: AuxJasper;
  currentRoute: string;
  showthings: boolean ;
  difInputs: boolean = false;
  // anio: number;
  // periodo: number;

  constructor(
    private catUsuariosService: ObtenerUsuarioPorCargoService,
    private route: ActivatedRoute,
    private router: Router,
    private privilegiosService: PrivilegiosService,
  ) { }

  async ngOnInit() {
    this.operaciones_mes = false;
    this.operaciones_anteriores = false;
    this.operaciones_canceladas = false;
    this.operaciones_padron = false;
    this.operaciones_facturados = false;
    await this.getPrivilegios();
    this.route.url.subscribe(url => {
      this.currentRoute = this.router.url;

      if(this.currentRoute.includes('ingresos/reportes')){
        this.showthings = true;
      }else{
        this.showthings = false;
      }
    });

    this.apertura_fecha = "2025-01-01";
  }


  async getPrivilegios() {
    try {

      let objUrl = new Privilegios();
      objUrl.uuid =  "e6ca9d29-234b-42b4-9975-7ce40ea445ab";
      let consultaPriv = await this.privilegiosService.GetPrivilegioByUUID(objUrl).toPromise();
      this.conPrivilegio = consultaPriv ? true : false;  
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getPrivilegios");
    }
}


  setSeleccionado(estado) {
    this.progressBar = false;
    this.progressButton = true;
    this.bloqueo_botones(this.boton_seleccionado);
    console.log('boton seleccionado', this.boton_seleccionado)
  }

  async reporte_Padron(fecha_apertura: any, fecha_cierre: any) {
    this.cambio_tabs(4);
    this.progressBar = true;
    try {
      if (fecha_apertura == "" && fecha_cierre == "" || fecha_apertura == "" || fecha_cierre == "") {
        this.muestraMensaje.error('Ingrese un rango de fechas.', "top", "center");
      }
      else {
        this.progressBar = true;
        // ESTA ES LA PRIMERA OPCION DE LOS RESPORTES
        //================================================================
        //================================================================
        this.buscando = true;

        ///////////////////////---Reporte padron-----////////////////////////////////
        ///////////////////////---Reporte padron-----////////////////////////////////
        let auxJasperReporte = new AuxJasper();
        auxJasperReporte.JasperReport.nombreReporte = "010_Reporte_Padron";
        auxJasperReporte.JasperReport.tipo = "pdf";
        const parametroJasper5 = new ParametroJasper();
        parametroJasper5.nombre = "p_fecha_ini";
        parametroJasper5.valor = fecha_apertura;
        await auxJasperReporte.ParametroJasper.push(parametroJasper5);
        const parametroJasper6 = new ParametroJasper();
        parametroJasper6.nombre = "p_fecha_out";
        parametroJasper6.valor = fecha_cierre;
        await auxJasperReporte.ParametroJasper.push(parametroJasper6);
        this.auxJasperReporte$.emit(auxJasperReporte);
      }
    } catch (e) {
      this.progressBar = false;
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.buscando = false;
      this.boton_seleccionado = 4;
    }
  }


  async operaciones_Anteriores(fecha_apertura: any, fecha_cierre: any) {
    this.cambio_tabs(2);
    try {
      if (fecha_apertura == "" && fecha_cierre == "" || fecha_apertura == "" || fecha_cierre == "") {
        this.muestraMensaje.error('Ingrese un rango de fechas.', "top", "center");
      }
      else {
        this.progressBar = true;
        // ESTA ES LA PRIMERA OPCION DE LOS RESPORTES
        //================================================================
        //================================================================
        this.buscando = true;

        ///////////////////////-- Fechas anteriores -----////////////////////////////////
        // ///////////////////////-- Fechas anteriores -----////////////////////////////////
        let auxJasperFechas = new AuxJasper();
        auxJasperFechas.JasperReport.nombreReporte = "010_Operaciones_Anteriores";
        auxJasperFechas.JasperReport.tipo = "pdf";
        const parametroJasper5 = new ParametroJasper();
        parametroJasper5.nombre = "p_fecha_ini";
        parametroJasper5.valor = fecha_apertura;
        await auxJasperFechas.ParametroJasper.push(parametroJasper5);
        const parametroJasper6 = new ParametroJasper();
        parametroJasper6.nombre = "p_fecha_out";
        parametroJasper6.valor = fecha_cierre;
        await auxJasperFechas.ParametroJasper.push(parametroJasper6);
        this.auxJasperFechas$.emit(auxJasperFechas);
      }
    } catch (e) {
      this.progressBar = false;
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.buscando = false;
      this.boton_seleccionado = 2;
    }
  }

  async operaciones_Canceladas(fecha_apertura: any, fecha_cierre: any) {
    this.cambio_tabs(3);
    try {
      if (fecha_apertura == "" && fecha_cierre == "" || fecha_apertura == "" || fecha_cierre == "") {
        this.muestraMensaje.error('Ingrese un rango de fechas.', "top", "center");
      }
      else {
        this.progressBar = true;
        // ESTA ES LA PRIMERA OPCION DE LOS RESPORTES
        //================================================================
        //================================================================
        this.buscando = true;


        // ///////////////////////---OPERACIONES CANCELADAS-----////////////////////////////////
        // ///////////////////////---OPERACIONES CANCELADAS-----////////////////////////////////
        let auxJasperCancelado = new AuxJasper();
        auxJasperCancelado.JasperReport.nombreReporte = "010_Operaciones_canceladas";
        auxJasperCancelado.JasperReport.tipo = "pdf";
        const parametroJasper = new ParametroJasper();
        parametroJasper.nombre = "p_fecha_ini";
        parametroJasper.valor = fecha_apertura;
        await auxJasperCancelado.ParametroJasper.push(parametroJasper);
        const parametroJasper2 = new ParametroJasper();
        parametroJasper2.nombre = "p_fecha_out";
        parametroJasper2.valor = fecha_cierre;
        await auxJasperCancelado.ParametroJasper.push(parametroJasper2);
        this.auxJasperCancelado$.emit(auxJasperCancelado);


      }
    } catch (e) {
      this.progressBar = false;
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.buscando = false;
      this.boton_seleccionado = 3;
    }
  }

  cambio_tabs(tab: number) {
    this.operaciones_mes = false;
    this.operaciones_anteriores = false;
    this.operaciones_canceladas = false;
    this.operaciones_padron = false;
    this.operaciones_ingresos = false;
    this.operaciones_facturados = false;
    switch (tab) {
      case 1:
        this.operaciones_mes = true;
        this.operaciones_anteriores = false;
        this.operaciones_canceladas = false;
        this.operaciones_padron = false;
        this.operaciones_ingresos = false;
        this.operaciones_facturados = false;
        break;
      case 2:
        this.operaciones_mes = false;
        this.operaciones_anteriores = true;
        this.operaciones_canceladas = false;
        this.operaciones_padron = false;
        this.operaciones_ingresos = false;
        this.operaciones_facturados = false;
        break;
      case 3:
        this.operaciones_mes = false;
        this.operaciones_anteriores = false;
        this.operaciones_canceladas = true;
        this.operaciones_padron = false;
        this.operaciones_ingresos = false;
        this.operaciones_facturados = false;
        break;
      case 4:
        this.operaciones_mes = false;
        this.operaciones_anteriores = false;
        this.operaciones_canceladas = false;
        this.operaciones_padron = true;
        this.operaciones_ingresos = false;
        this.operaciones_facturados = false;
        break;
      case 5:
        this.operaciones_mes = false;
        this.operaciones_anteriores = false;
        this.operaciones_canceladas = false;
        this.operaciones_padron = false;
        this.operaciones_ingresos = true;
        this.operaciones_facturados = false;
        break;
        case 6:
        this.operaciones_mes = false;
        this.operaciones_anteriores = false;
        this.operaciones_canceladas = false;
        this.operaciones_padron = false;
        this.operaciones_ingresos = false;
        this.operaciones_facturados = true;
        break;
      default:

        break;
    }
  }

  bloqueo_botones(boton: number) {
    switch (boton) {
      case 1:
        this.boton_mes = true;
        break;
      case 2:
        this.boton_anteriores = true;
        break;
      case 3:
        this.boton_canceladas = true;
        break;
      case 4:
        this.boton_padron = true;
        break;
      case 5:
        this.boton_ingresos = true;
        break;
       /* case 6:
        this.boton_facturados = true;
        break;*/
      default:

        break;
    }
  }

  async operaciones_Mes(fecha_apertura: any, fecha_cierre: any) {
    this.cambio_tabs(1);
    try {
      if (fecha_apertura == "" && fecha_cierre == "" || fecha_apertura == "" || fecha_cierre == "") {
        this.muestraMensaje.error('Ingrese un rango de fechas.', "top", "center");
      }
      else {
        this.progressBar = true;
        // ESTA ES LA PRIMERA OPCION DE LOS RESPORTES
        //================================================================

        let auxJasperFechas = new AuxJasper();
        auxJasperFechas.JasperReport.nombreReporte = "010_Operaciones_Fecha";
        auxJasperFechas.JasperReport.tipo = "pdf";
        auxJasperFechas.JasperReport.imprimir = true;
        const parametroJasper = new ParametroJasper();
        parametroJasper.nombre = "p_fecha_ini";
        parametroJasper.valor = fecha_apertura;

        const parametroJasper2 = new ParametroJasper();
        parametroJasper2.nombre = "p_fecha_out";
        parametroJasper2.valor = fecha_cierre;
        await auxJasperFechas.ParametroJasper.push(parametroJasper2);
        await auxJasperFechas.ParametroJasper.push(parametroJasper);
        this.auxJasperFechas$.emit(auxJasperFechas);
      }
    } catch (e) {
      this.progressBar = false;
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.buscando = false;
      this.boton_seleccionado = 1;
    }

  }

  async Ingresos(fecha_apertura: any, fecha_cierre: any) {
    this.cambio_tabs(5);

    try {
      if (fecha_apertura == "" && fecha_cierre == "" || fecha_apertura == "" || fecha_cierre == "") {
        this.muestraMensaje.error('Ingrese un rango de fechas.', "top", "center");
      }
      else {
        this.progressBar = true;
        // ESTA ES LA PRIMERA OPCION DE LOS RESPORTES
        //================================================================

        let auxJasperIngresos = new AuxJasper();
        auxJasperIngresos.JasperReport.nombreReporte = "010_Resumen_recaudacion";
        auxJasperIngresos.JasperReport.tipo = "pdf";
        const parametroJasper = new ParametroJasper();
        parametroJasper.nombre = "p_fecha_ini";
        parametroJasper.valor = fecha_apertura;

        const parametroJasper2 = new ParametroJasper();
        parametroJasper2.nombre = "p_fecha_out";
        parametroJasper2.valor = fecha_cierre;
        await auxJasperIngresos.ParametroJasper.push(parametroJasper2);
        await auxJasperIngresos.ParametroJasper.push(parametroJasper);
        this.auxJasperIngresos$.emit(auxJasperIngresos);
      }
    } catch (e) {
      this.progressBar = false;
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.buscando = false;
      this.boton_seleccionado = 5;
    }

  }

  async ingresosFacturados(fecha_apertura: any, fecha_cierre: any) {
    this.cambio_tabs(6);

    try {
      if (fecha_apertura == "" && fecha_cierre == "" || fecha_apertura == "" || fecha_cierre == "") {
        this.muestraMensaje.error('Ingrese un rango de fechas.', "top", "center");
      }
      else {
        this.progressBar = true;
        // ESTA ES LA PRIMERA OPCION DE LOS RESPORTES
        //================================================================

        let auxJasperIngresosFacturados = new AuxJasper();
        auxJasperIngresosFacturados.JasperReport.nombreReporte = "037_ingresos_mes_facturados";
        auxJasperIngresosFacturados.JasperReport.tipo = "pdf";
        auxJasperIngresosFacturados.JasperReport.imprimir = true;
        const parametroJasper = new ParametroJasper();
        parametroJasper.nombre = "p_fecha_ini";
        parametroJasper.valor = fecha_apertura + '';

        const parametroJasper2 = new ParametroJasper();
        parametroJasper2.nombre = "p_fecha_out";
        parametroJasper2.valor = fecha_cierre + '';

        const parametroJasper3 = new ParametroJasper();
        parametroJasper3.nombre = "tipo";
        parametroJasper3.valor = 'pdf';
        await auxJasperIngresosFacturados.ParametroJasper.push(parametroJasper3);
        await auxJasperIngresosFacturados.ParametroJasper.push(parametroJasper2);
        await auxJasperIngresosFacturados.ParametroJasper.push(parametroJasper);
        this.auxJasperIngresosFacturados$.emit(auxJasperIngresosFacturados);
      }
    } catch (e) {
      this.progressBar = false;
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.buscando = false;
      this.boton_seleccionado = 6;
    }

  }

  async ingresosFacturadosExcel(fecha_apertura: any, fecha_cierre: any) {
    this.cambio_tabs(6);

    try {
      this.progressBar = true;
      if (fecha_apertura == "" && fecha_cierre == "" || fecha_apertura == "" || fecha_cierre == "") {
        this.muestraMensaje.error('Ingrese un rango de fechas.', "top", "center");
      }
      else {
        //this.progressBar = true;
        // ESTA ES LA PRIMERA OPCION DE LOS RESPORTES
        //================================================================

        let auxJasperIngresosFacturados = new AuxJasper();
        auxJasperIngresosFacturados.JasperReport.nombreReporte = "037_ingresos_mes_facturados";
        auxJasperIngresosFacturados.JasperReport.tipo = "xlsx";
        const parametroJasper = new ParametroJasper();
        parametroJasper.nombre = "p_fecha_ini";
        parametroJasper.valor = fecha_apertura + '';

        const parametroJasper2 = new ParametroJasper();
        parametroJasper2.nombre = "p_fecha_out";
        parametroJasper2.valor = fecha_cierre + '';

        const parametroJasper3 = new ParametroJasper();
        parametroJasper3.nombre = "tipo";
        parametroJasper3.valor = 'xlsx';
        await auxJasperIngresosFacturados.ParametroJasper.push(parametroJasper3);
        await auxJasperIngresosFacturados.ParametroJasper.push(parametroJasper2);
        await auxJasperIngresosFacturados.ParametroJasper.push(parametroJasper);
        this.auxJasperIngresosFacturados$.emit(auxJasperIngresosFacturados);
      }
    } catch (e) {
      //this.progressBar = false;
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.buscando = false;
      this.boton_seleccionado = 6;
      setTimeout(() =>{
        this.progressBar = false;
      }, 5000);// posiblemente habra que cambiarlo 
    }
  }

  async generaExcel(anio:any, periodo: any) {
    //this.cambio_tabs(6);

    try {
      this.progressBar = true;
      /*if (anio == "" && anio == "" || mes == "" || mes == "") {
        this.muestraMensaje.error('Ingrese un rango de fechas.', "top", "center");
      }
      else {*/
        //this.progressBar = true;
        // ESTA ES LA PRIMERA OPCION DE LOS RESPORTES
        //================================================================

          ///////////////////////---CAMBIO DE PROPIETARIO-----////////////////////////////////

          console.log("Entra a: ", this.boton_seleccionado)
          console.log("anio:", anio);
          console.log("periodo", periodo);
      if(this.boton_seleccionado === 1){
        let auxJasperReporte2 = new AuxJasper();
        auxJasperReporte2.JasperReport.nombreReporte = "041_Consumos_Gobierno";
        auxJasperReporte2.JasperReport.tipo = "xlsx";
        const parametroJasper = new ParametroJasper();
        parametroJasper.nombre = "_anio";
        parametroJasper.valor = anio + "";

        const parametroJasper2 = new ParametroJasper();
        parametroJasper2.nombre = "_periodo_parcialidad";
        parametroJasper2.valor = periodo + "";

        await auxJasperReporte2.ParametroJasper.push(parametroJasper2);
        await auxJasperReporte2.ParametroJasper.push(parametroJasper);
        this.auxJasperReporte2$.emit(auxJasperReporte2);

      }else if(this.boton_seleccionado === 2){
        let auxJasperReporte1 = new AuxJasper();
        auxJasperReporte1.JasperReport.nombreReporte = "042_Consumos_Empleados";
        auxJasperReporte1.JasperReport.tipo = "xlsx";
        const parametroJasper = new ParametroJasper();
        parametroJasper.nombre = "_anio";
        parametroJasper.valor = anio + "";

        const parametroJasper2 = new ParametroJasper();
        parametroJasper2.nombre = "_periodo_parcialidad";
        parametroJasper2.valor = periodo + "";

        await auxJasperReporte1.ParametroJasper.push(parametroJasper2);
        await auxJasperReporte1.ParametroJasper.push(parametroJasper);
        this.auxJasperReporte1$.emit(auxJasperReporte1);
      }

      //}
    } catch (e) {
      //this.progressBar = false;
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.buscando = false;
      this.boton_seleccionado = 6;
      setTimeout(() =>{
        this.progressBar = false;
      }, 5000);// posiblemente habra que cambiarlo 
    }

  }

  async consultarReportes(fecha_apertura: any, fecha_cierre: any){
    try {
      if (fecha_apertura == "" && fecha_cierre == "" || fecha_apertura == "" || fecha_cierre == "") {
        this.muestraMensaje.error('Ingrese un rango de fechas.', "top", "center");
      }
      else {
        this.progressBar = true;
        //validacion de que los paramertos no esten vacios 

      let fechaApertura = new ParametroJasper();
      let fechaCierre = new ParametroJasper();

      fechaApertura.nombre = "_fecha_inicio";  // este es el nombre del parametro, por eso mismo estos dos llevan el mismo nombre
      fechaApertura.valor = fecha_apertura + '' ;  // este es el valor que se envia 
      fechaCierre.nombre = "_fecha_fin";
      fechaCierre.valor = fecha_cierre + '';  // tenemos que tomar y poner los valores de las fechas aqui, busca aqui arriba el como mando las fechas

      ///////////////////////--- Rutas-----////////////////////////////////
      if(this.conPrivilegio)
      {
        this.auxJasperRutasProcesadas = new AuxJasper();
        this.auxJasperRutasProcesadas.JasperReport.nombreReporte =
          "041_reporte_rutas";
        this.auxJasperRutasProcesadas.JasperReport.tipo = "pdf";
  
        await this.auxJasperRutasProcesadas.ParametroJasper.push(fechaApertura);
        await this.auxJasperRutasProcesadas.ParametroJasper.push(fechaCierre);
       
        let emiteJasperRutas = new AuxJasper();
        emiteJasperRutas = this.auxJasperRutasProcesadas;
        this.auxJasperRutasProcesadas$.emit(emiteJasperRutas);
      }

      }
    } catch (e) {
    } finally {
      this.progressBar = false;
    }
}
    
getInputs(){
  if(!this.showthings){
    if(this.boton_seleccionado === 1 || this.boton_seleccionado === 2){
      this.difInputs = true;
    }else{
      this.difInputs = false;
    }
  }
}

  handleChange(e) {
    var index = e.index;
    this.boton_seleccionado = index;
    this.getInputs(); 
    if(e.index == 0) 
      this.apertura_fecha = "2025-01-01";
    }
}

